import axios from 'axios'

export const exchangeApi = axios.create({
  baseURL: 'https://currency-converter-pro1.p.rapidapi.com',
  headers: {
    Accept: 'application/json',
    'X-RapidAPI-Key': 'a40192c73amsh0302cb07f06b023p1970a0jsn394f41abb5e3',
    'X-RapidAPI-Host': 'currency-converter-pro1.p.rapidapi.com',
  },
})
